import React, { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const BaseUrlProvider = ({ children }) => {
  const [baseUrl, setBaseUrl] = useState("http://127.0.0.1:8000/api");
  const [baseUrlForFile, setBaseUrlForFile] = useState("http://127.0.0.1:8000/storage");

  // ✅ FIXED REGEX
  const stringExp = /^[A-Za-z]{1,30}$/;
  const usernameRegex = /^[A-Za-z0-9]{5,30}$/;
  const emailRegex = /^[A-Za-z0-9#$%&*^!]{3,}@[a-z]{3,}\.[a-z]{2,}$/;
  const passwordRegex = /^[A-Za-z0-9@#$%^&*!]{8,}$/;
  const phoneRegex = /^[0-9]{11}$/;
  const numberRegex=/^[0-9]{1,20}$/;

const regExpChecker = (type, inp, extra = "") => {
    switch (type) {

      case "string":
  if (!stringExp.test(inp)) {
    return "Only alphabets allowed (5-30 chars)";
  }
  return "";

      case "username":
        if (!usernameRegex.test(inp)) {
          return "Username must be 5-30 characters";
        }
        return "";

      case "email":
        if (!emailRegex.test(inp)) {
          return "Invalid Email";
        }
        return "";

      case "password":
        if (!passwordRegex.test(inp)) {
          return "Password must be at least 8 characters";
        }
        return "";

       case "confirmPassword":
  if (inp !== extra) {
    return "Password Don't Match";
  }
  return "";

  case "phone":
  if (!phoneRegex.test(inp)) {
    return "Phone must be 11 digits";
  }
  return "";

  case "number":
    if(!numberRegex.test(inp)){
      return "Enter Numbers Only";
    }
    return "";
    }
  };

  return (
    <AppContext.Provider value={{ baseUrl, baseUrlForFile, regExpChecker }}>
      {children}
    </AppContext.Provider>
  );
};

export const useBaseUrl = () => useContext(AppContext);

export default AppContext;